/* eslint-disable require-jsdoc */
/* eslint-disable comma-dangle */
/* eslint-disable semi */
/* eslint-disable no-trailing-spaces */
import { AxiosStatic } from 'axios';

export default class LoginService {
    axios;
    constructor(axios: AxiosStatic) {
        this.axios = axios;
    }
    async login(email, password): Promise<{token: string, refreshToken: string}> {
        try {
            const response = await this.axios.post('/auth', {
                email,
                password
            });
            // console.log(response.data?.accessToken)
            return {
                token: response.data?.accessToken,
                refreshToken: response.data?.refreshToken
            };
        } catch (error) {
           throw error
        }
        
    }
}
